import { isEqual, mapValues } from "lodash-es";

export function deepCompareObjects<T extends object>(
  a: T,
  b: T,
): Record<keyof T, boolean> {
  return mapValues(
    a,
    (value: T[keyof T], key: keyof T) => !isEqual(value, b[key]),
  );
}
